import { withLocalState } from 'pyradux';

import HealthContainer from './Health.container';
import reducer from './Health.reducer';
import HealthSagas from './Health.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'health',
  sagas: [HealthSagas],
};

export default withLocalState(withLocalStateOptions, HealthContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Health/index.js